import { z } from 'zod';
import { COMPANY_CONSTRAINTS } from './constraints.js';
import { checkTaxExemptNumberRequired } from './rules.js';
export const createCompanyInputSchema = z
    .object({
    name: z
        .string()
        .trim()
        .min(1, `${COMPANY_CONSTRAINTS.name.label} is required`)
        .max(COMPANY_CONSTRAINTS.name.maxLength, `${COMPANY_CONSTRAINTS.name.label} must be ${COMPANY_CONSTRAINTS.name.maxLength} characters or fewer`),
    taxExempt: z.boolean(),
    taxexemptnumber: z
        .string()
        .trim()
        .max(COMPANY_CONSTRAINTS.taxexemptnumber.maxLength, `${COMPANY_CONSTRAINTS.taxexemptnumber.label} must be ${COMPANY_CONSTRAINTS.taxexemptnumber.maxLength} characters or fewer`)
        .optional()
        .nullable(),
})
    .superRefine((data, ctx) => {
    const message = checkTaxExemptNumberRequired(data);
    if (message) {
        ctx.addIssue({ code: 'custom', message, path: ['taxexemptnumber'] });
    }
});
//# sourceMappingURL=create-input.js.map